<template>
  <div v-if="!item.hidden">
    <!-- 叶子菜单 -->
    <el-menu-item v-if="!item.children" :index="item.path" @click="clickMenu(item)">
        <!-- <img v-if="item.meta.icon" :src="require('@/assets/images/'+item.meta.icon+'.png')"/> -->
        <span slot="title" style="margin-left: 4px;">{{ item.meta.title}}</span>
    </el-menu-item>
    <!-- 特殊一级菜单，例如首页 -->
      <el-menu-item v-else-if="!item.meta" :index="item.children[0].path" @click="clickMenu(item.children[0])">
        <img v-if="item.children[0].meta.icon" :src="require('@/assets/images/'+item.children[0].meta.icon+'.png')"/>
        <span slot="title" style="margin-left: 4px;">{{ item.children[0].meta.title}}</span>
    </el-menu-item>
    <!-- 一级菜单 -->
    <el-submenu v-else :index="item.path">
      <template slot="title">
        <img v-if="item.meta.icon" :src="require('@/assets/images/'+item.meta.icon+'.png')" class="menu-icon"/>
        <span slot="title" style="margin-left: 4px;">{{ item.meta.title }}</span>
      </template>
      <!-- 还有二级菜单 -->
      <el-menu-item-group>
        <SidebarItem v-for="(route,index) in item.children" :key="route.path+index" :item="route" :base-path="route.path" :isHideTips="true" @clickMenu="clickMenu(route)" />
      </el-menu-item-group>
      
    </el-submenu>
  </div>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    // 点击菜单
    clickMenu(value) {
      this.$emit('clickMenu', value)
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-menu-item.is-active .menu-icon,
  .el-menu-item:hover .menu-icon {
    filter: brightness(0) invert(1); /* 应用图片逆色效果 */
  }
  .el-submenu__title:hover .menu-icon{
    filter: brightness(0) invert(1); /* 应用图片逆色效果 */
  }
  ::v-deep .el-menu-item-group__title{
    padding: 0;
  }
</style>
